import React, {useState} from 'react'
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import BoutonIcon from "../atomes/boutonIcon";
import EtoileIcon from "../icons/etoile";
import Overlay from "./overlay";

const Header = ({ etoiles }) => {
    const navigate = useNavigate();
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const [lien, setLien] = useState('');

    const openOverlay = (videoUrl) => {
        setLien(videoUrl);
        setIsOverlayOpen(true);
    }

    const handleLogoClick = () => {
        navigate('/');
    }

    return (
        <>
            <header className="bg-black text-white p-3 md:p-6 shadow-md relative">
                <img
                    src={process.env.PUBLIC_URL + '/images/logo.webp'}
                    alt="Logo"
                    className="hidden md:block w-24 h-24 absolute left-6 top-1 cursor-pointer hover:opacity-80 transition-opacity"
                    onClick={handleLogoClick}
                />
                <div className="text-center">
                    <div className="flex gap-3 justify-center">
                        {etoiles.map((lienVideo, index) => (
                            <BoutonIcon
                                key={index}
                                icon={<EtoileIcon/>}
                                onClick={() => openOverlay(lienVideo)}
                                transparent
                                height={8}
                                width={8}
                            />
                        ))}
                    </div>
                </div>
            </header>
            {isOverlayOpen && (
                <Overlay onClose={() => setIsOverlayOpen(false)}>
                    <iframe
                        src={lien}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="w-[90vw] h-[90vh] max-w-[1600px] max-h-[900px] rounded-md"
                    />
                </Overlay>
            )}
        </>
    )
}

Header.propTypes = {
    etoiles: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default Header